import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const PENDING_INVITE_KEY = "nimbus_pending_invite";

export const myInvites = () => axios.get(`${API}/invites`, { withCredentials: true }).then((r) => r.data);
export const respondInvite = (id, accept, code) =>
  axios.post(`${API}/invites/${id}/${accept ? "accept" : "decline"}`, code ? { code } : {}, { withCredentials: true }).then((r) => r.data);
export const lookupInviteToken = (token) =>
  axios.post(`${API}/invites/lookup-link`, { token }).then((r) => r.data);
export const respondInviteToken = (token, accept, code) =>
  axios.post(`${API}/invites/${accept ? "accept" : "decline"}-link`, { token, code: code || "" }, { withCredentials: true }).then((r) => r.data);
export const teamInvites = (teamId) =>
  axios.get(`${API}/teams/${teamId}/invites`, { withCredentials: true }).then((r) => r.data);
export const revokeInvite = (teamId, inviteId) =>
  axios.delete(`${API}/teams/${teamId}/invites/${inviteId}`, { withCredentials: true }).then((r) => r.data);
export const resendVerification = () =>
  axios.post(`${API}/auth/verify-email/resend`, {}, { withCredentials: true }).then((r) => r.data);
export const errText = (e, fallback) => {
  const d = e?.response?.data?.detail;
  return typeof d === "string" ? d : fallback;
};
